import React from 'react';
import { Link } from 'react-router-dom';
import { LoadingIndicator } from 'react-select/src/components/indicators';
import { ProgressBar } from 'react-toastify/dist/components';
import { EntrataIntegratedBuilding } from '~/api/buildingEntrataIntegration';
import CircularProgressBar from '~/components/CircularProgressBar/CircularProgressBar';
import Spinner from '~/components/Spinner/Spinner';

export const buildingEntrataIntegrationTableColumns = ({
  downloadEntrataCsv,
  onEditClicked,
  onSyncClicked,
  getDeactivationLogs,
  onDeleteClicked,
  buildingIntegrationsBeingSynced
}: {
  downloadEntrataCsv: (buildingId: string) => void;
  onEditClicked: (integration: EntrataIntegratedBuilding) => void;
  onSyncClicked: (integration: EntrataIntegratedBuilding) => void;
  getDeactivationLogs: (integrationId: string) => void;
  onDeleteClicked: (integrationId: string) => void;
  buildingIntegrationsBeingSynced: any;
}) => [
  {
    Header: 'PROPERTY',
    disableSortBy: true,
    accessor: (row: EntrataIntegratedBuilding) => (
      <Link to={`/building/${row.buildingId}`}>{row.buildingName}</Link>
    )
  },
  {
    Header: 'DOMAIN',
    disableSortBy: true,
    accessor: (row: EntrataIntegratedBuilding) => <div>{row.domain}</div>
  },
  {
    Header: 'USERNAME',
    disableSortBy: true,
    accessor: (row: EntrataIntegratedBuilding) => <div>{row.username}</div>
  },
  {
    Header: 'PROPERTY ID',
    disableSortBy: true,
    accessor: (row: EntrataIntegratedBuilding) => <div>{row.propertyId}</div>
  },
  {
    Header: 'OWNER',
    disableSortBy: true,
    accessor: (row: EntrataIntegratedBuilding) => (
      <div>{row.ownerGroup ?? 'N/A'}</div>
    )
  },
  {
    Header: 'PROPERTY MGMT GROUP',
    disableSortBy: true,
    accessor: (row: EntrataIntegratedBuilding) => (
      <div>{row.pmOwnerGroup ?? 'N/A'}</div>
    )
  },
  {
    Header: '# OF RECORDS',
    disableSortBy: true,
    accessor: (row: EntrataIntegratedBuilding) => (
      <div>{row.totalRecordsSynced ?? 0}</div>
    )
  },
  {
    Header: 'LAST SYNCED',
    disableSortBy: true,
    accessor: (row: EntrataIntegratedBuilding) => (
      <div>
        {row.lastSyncTime
          ? new Date(row.lastSyncTime).toLocaleDateString()
          : 'N/A'}
      </div>
    )
  },
  {
    Header: 'STATUS',
    disableSortBy: true,
    accessor: (row: EntrataIntegratedBuilding) => (
      <div className={`last-sync-status-${row.lastSyncStatus}`}>
        {row.lastSyncStatus}
      </div>
    )
  },
  {
    Header: 'ACTIONS',
    disableSortBy: true,
    accessor: (row: EntrataIntegratedBuilding) => {
      if (buildingIntegrationsBeingSynced[row.buildingId]) {
        return (
          <div
            style={{
              display: 'flex',
              left: 0,
              top: 0,
              height: '100%',
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10
            }}
          >
            <Spinner />
          </div>
        );
      }

      return (
        <div>
          <div>
            <button
              className='btn btn-primary btn-small'
              onClick={() => downloadEntrataCsv(row.buildingId)}
            >
              DOWNLOAD CSV
            </button>
            <button
              className='btn btn-secondary btn-small margin-left-16'
              onClick={() => onEditClicked(row)}
            >
              EDIT
            </button>

            <button
              className='btn btn-secondary btn-small margin-left-16'
              onClick={() => onSyncClicked(row)}
            >
              Sync Now{' '}
            </button>

            {row.lastSyncStatus == 'SUCCESS' && (
              <button
                className='btn btn-secondary btn-small margin-left-16'
                onClick={() => getDeactivationLogs(row.integrationId)}
              >
                View Logs
              </button>
            )}
            <button
              className='btn btn-danger btn-small margin-left-16'
              onClick={() => onDeleteClicked(row.integrationId)}
            >
              DELETE
            </button>
          </div>
        </div>
      );
    }
  }
];
